import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

const modifiers = {
  errorMessage: ({ theme }) => ({
    styles: `
      background-color: ${theme.redLight1};
      border: solid 1px ${theme.redLight2};
      color: ${theme.red};
    `,
  }),
};

export const WarningStyled = styled.div.attrs({
  className: 'component__Warning',
})`
  width: 100%;
  height: auto;
  min-height: 2.65rem;
  padding: 0.5rem;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;

  svg {
    width: 1rem;
    height: 1rem;
    margin-right: 0.5rem;
    fill: #EE3524;
  }

  span {
    font-size: 0.875rem;
    font-weight: 700;
    display: block;
  }
  
  ${applyStyleModifiers(modifiers)};
`;
